<template>
  <div>
    <div class="opc-cart-item__text" v-if="mx_is">
      <span style="vertical-align: middle">
        {{ $t("billing.prorated.charged_period") }}
        <vloader :loading="mx_loading" :value="displayPeriod" />
      </span>
      &nbsp;
      <zm-tooltip
        :content="$t('billing.prorated.prorated_period_tooltip')"
        role="button"
        aria-label="Learn more about Prorated charge"
      >
        <i class="zm-icon-info-outline" style="position: relative; top: -1px; color: #666487; font-size: 16px" />
      </zm-tooltip>
    </div>
    <slot v-else></slot>
  </div>
</template>

<script>
import { dateTimeFormat } from '@/utils/dateformat';
import { mapGetters } from 'vuex';
import mx from './mx.vue';
import vloader from './vloader.vue';
import { PRORATED_OF } from '@/store/modules/preview';
export default {
  mixins: [mx],
  components: {
    vloader,
  },
  computed: {
    ...mapGetters(['getProratedChargeDetails']),
    currentDate() {
      return dateTimeFormat(new Date());
    },
    nextBillingDate() {
      const found = this.getProratedChargeDetails.find((x) => x.of == PRORATED_OF.UPDATED && x.planCode === this.mx_cartPlan.plan_code);
      if (!found) return '';
      return dateTimeFormat(new Date(found.prorationEndDate));
    },
    displayPeriod() {
      return `${this.currentDate} - ${this.nextBillingDate}`;
    },
  },
};
</script>